import {IHistory} from "@redux/actions/navigatorAction";

export const navigatorHelper = (state = {
  previous: {},
  current: {},
  query: {},
}, action: any): { previous: {}; current: {}; query: {} } => {
  switch (action.type) {
    case 'SET_PREVIOUS_URL':
      return {
        ...state,
        ...action.history
      }
    default:
      return state
  }
}